import { faAngleDown } from "@jewlr/pro-regular-svg-icons/faAngleDown"
import { faAngleUp } from "@jewlr/pro-regular-svg-icons/faAngleUp"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import Divider from "components/ui/divider"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Picture from "components/ui/picture"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

import Accordion from "../accordion"
import { AccordionHeading } from "../components"

import WhatsCovered from "./whats-covered"

const extendFaq = () => [
  {
    title: "Why Should I add an accidental damage plan?",
    why: [
      {
        content: (
          <>
            This type of plan provides accident protection from damaged prongs,
            clasps, hinges, and more. Extend plans are in effect from day one,
            and even extend your coverage from defects in workmanship and/or
            materials, including normal wear and tear after the
            manufacturer&apos;s warranty expires.
            <br />
            <br />
            Please click{" "}
            <Button asChild underline>
              <a
                href="https://customers.extend.com/en-US/plan_details/A0-AAJEW-5y"
                rel="nofollow noopener"
              >
                here
              </a>
            </Button>{" "}
            to learn more about Extend ADH Protection Plans.
          </>
        ),
      },
    ],
  },
  {
    title: `How can I purchase an extend ${jewlr_t(
      "terms.jewelry"
    )} ADH protection plan?`,
    why: [
      {
        content: (
          <>
            An Extend {jewlr_t("terms.Jewelry")} ADH Protection Plan can be
            purchased during the checkout process online or by contacting our
            Customer Service Team at{" "}
            <Button asChild underline>
              <a
                href={`tel::${sl.config.customer_service_toll_free}`}
                rel="nofollow"
              >
                {sl.config.customer_service_toll_free}
              </a>
            </Button>
            .
            <br />
            <br />
            You can also purchase a {jewlr_t("terms.Jewelry")} ADH Protection
            Plan retroactively up to 60 days past the date you purchased your{" "}
            {jewlr_t("terms.jewelry")} item.
            <br />
            <br />
            Please click{" "}
            <Button asChild underline>
              <a
                href="https://customers.extend.com/en-US/plan_details/A0-AAJEW-5y"
                rel="nofollow noopener"
              >
                here
              </a>
            </Button>{" "}
            to learn more about Extend ADH Protection Plans.
          </>
        ),
      },
    ],
  },
  {
    title: "What products are covered?",
    why: [
      {
        content: (
          <>
            The Extend {jewlr_t("terms.Jewelry")} ADH Protection Plan covers
            bracelets, earrings, necklaces, rings, charms and pendants,{" "}
            {jewlr_t("terms.Jewelry")}
            sets, anklets, brooches, and lapel pins. The Extend team and Jewlr
            work together to identify all eligible products and match them to a
            protection plan.
            <br />
            <br />
            Please click{" "}
            <Button asChild underline>
              <a
                href="https://customers.extend.com/en-US/plan_details/A0-AAJEW-5y"
                rel="nofollow noopener"
              >
                here
              </a>
            </Button>{" "}
            to learn more about Extend ADH Protection Plans.
          </>
        ),
      },
    ],
  },
  {
    title: "What if I need to make a claim?",
    why: [
      {
        content: (
          <>
            Extend makes it easy to file a claim either through their online
            portal or call center.
            <br />
            <br />
            When filing a claim with Extend, you will simply need to provide
            either your contract ID, email address, or another identifying piece
            of information.
            <br />
            <br />
            To start your claim, please contact Extend at{" "}
            <Button asChild underline>
              <a
                href="https://customers.extend.com/claims"
                rel="nofollow noopener"
              >
                customers.extend.com/claims
              </a>
            </Button>{" "}
            or by phone at{" "}
            <Button asChild underline>
              <a href="tel:877-248-7707" rel="nofollow noopener">
                (877) 248-7707
              </a>
            </Button>
            .
          </>
        ),
      },
    ],
  },
]

const JewlrExtend = ({ setShowExtend, showExtend }) => {
  const faqData = extendFaq()

  return (
    <div
      className="max-w-1530 desktop:my-90 widescreen:px-60 mx-auto"
      id="jewlr-extend-warranty"
    >
      <h3>
        <AccordionHeading
          aria-controls="protection-coverage-content"
          aria-expanded={showExtend}
          aria-label="Learn more about Extend protection coverage"
          className="bg-grey-200 desktop:inline-flex desktop:py-60 widescreen:px-60 block p-32 text-left"
          id="protection-coverage-heading"
          onClick={() => setShowExtend(!showExtend)}
        >
          <Picture
            alt="Jewlr + Extend"
            className="w-(--base-width) tablet:w-(--tablet-width)"
            fallback="https://cms.jewlr.com/jewlr_extend_2x_8380e58ead/jewlr_extend_2x_8380e58ead.png"
            srcSet={[
              {
                height: 50,
                media: "(max-width: 767px)",
                sizes: "264px",
                srcSet: getImgSrcSet(
                  `${sl.config.jewlr_imgsmbly_url}cms/m_jewlr_extend_2x_62aff472a9/m_jewlr_extend_2x_62aff472a9.png`,
                  622
                ),
                width: 622,
              },
              {
                height: 284,
                media: "(min-width: 768px)",
                sizes: "524px",
                srcSet: getImgSrcSet(
                  `${sl.config.jewlr_imgsmbly_url}cms/jewlr_extend_2x_8380e58ead/jewlr_extend_2x_8380e58ead.png`,
                  1544
                ),
                width: 1544,
              },
            ]}
            style={{
              "--base-width": "264px",
              "--tablet-width": "524px",
            }}
          />
          <div className="tablet:mt-0 mt-20 flex items-center">
            <p className="text-18 tablet:text-34 tablet:font-bold font-semibold">
              Learn more
            </p>
            <FontAwesomeIcon
              className="text-12 tablet:text-32 tablet:ml-20 ml-8"
              icon={showExtend ? faAngleUp : faAngleDown}
            />
          </div>
        </AccordionHeading>
      </h3>
      <Expand
        aria-labelledby="protection-coverage-heading"
        className="widescreen:px-60 mt-24 px-16"
        id="protection-coverage-content"
        show={showExtend}
      >
        <WhatsCovered />
        <h2 className="h2 desktop:mb-32 mb-24">Extend FAQ&apos;s</h2>
        <Divider className="bg-black" />
        {faqData.map((data, i) => (
          <Accordion data={data} key={`why${i}`} />
        ))}
        <Button asChild className="body desktop:mb-64 mb-32 mt-32" underline>
          <Link to="/helpdesk">Read more FAQ&apos;s here</Link>
        </Button>
        <p className="body desktop:mb-20 mb-10 font-semibold">
          Warranty Terms and Conditions
        </p>
        <p className="body-sm desktop:mb-0 mb-40">
          If your piece is out of warranty, don&apos;t worry! You can still send
          it to us for repairs (fees apply). Contact our customer experience
          team for a quote and instructions on how to send it in.
        </p>
      </Expand>
    </div>
  )
}

JewlrExtend.propTypes = {
  setShowExtend: PropTypes.func,
  showExtend: PropTypes.bool,
}

export default JewlrExtend
